import { render, staticRenderFns } from "./collectTask.vue?vue&type=template&id=78082118&scoped=true"
import script from "./collectTask.vue?vue&type=script&lang=js"
export * from "./collectTask.vue?vue&type=script&lang=js"
import style0 from "./collectTask.vue?vue&type=style&index=0&id=78082118&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78082118",
  null
  
)

export default component.exports